export default __webpack_public_path__ + "static/app-home-page-ce2e4d12f2f72a622842a062f1c4b4a8.svg";